// Curated reaction set — must stay in sync with ALLOWED_REACTIONS in the backend
// (api/employee-chat/employee-chat.constants.js).
export const CHAT_REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '🙏', '🎉', '👏'];
